import { ZIBUZZ_API_GATEWAY } from './mappedEnv';

// ============= List of APIs for ZIBUZZ =============

export const userManagementApi = `${ZIBUZZ_API_GATEWAY}/Validate`;
export const messagingApi = `${ZIBUZZ_API_GATEWAY}/messaging`;
export const mediaApi = `${ZIBUZZ_API_GATEWAY}/media`;
